import HlsSubtitles from './hls-subtitles';
import * as device from '../../util/device';

export default class HlsNativeSubtitles extends HlsSubtitles {
    show() {
        if (this.videoElement && this.videoElement.textTracks.length > 0) {
            this.videoElement.textTracks[0].mode = device.isIOS() ? 'showing' : 'hidden';
        }
    }

    hide() {
        if (this.videoElement && this.videoElement.textTracks.length > 0) {
            this.videoElement.textTracks[0].mode = 'disabled';
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/modules/hls/hls-native-subtitles.js